<template>
  <section class="content">
    <!-- Default box -->
    <div class="box mt-2">
            <div class="box-header">
              <h3 class="box-title"><b>ACS Panel Payment Summary</b></h3>
              <hr>
            </div>
            <!-- /.box-header -->
            <div class="box-body" style="min-height: 800px;height: auto;">
              <div class="box-header with-border" style="padding: 11px;padding-right: 0px;">
              </div>
              <div id="example1_wrapper" class="dataTables_wrapper form-inline dt-bootstrap">
                <div class="row">
                  <div class="col-sm-12">
                    <div style="margin-top: 20%;text-align:center" v-if="userslistlength < 1">
                      <img src="../../assets/img/nodata.svg" alt="Product Image" style="width: 80px;">
                    </div>
                    <div class="table-responsive text-nowrap">
                  <table v-if="userslistlength > 0" id="example1" class="table table-striped" role="grid" aria-describedby="example1_info" style="font-size: 12px;">
                <thead>
                  <tr role="row" class="tc">
                    <th class="sorting_asc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Rendering engine: activate to sort column descending" style="width: 44px;"></th>
                    <th class="sorting tc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Panel Member's</th>
                    <th class="sorting tc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Panel Member's</th>
                    <th class="sorting tc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">#EP Screening</th>
                    <th class="sorting tc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending">Amount Due</th>
                  </tr>
                  <tr role="row" class="tc">
                    <th class="sorting_asc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-sort="ascending" aria-label="Rendering engine: activate to sort column descending" style="width: 44px;">S.No</th>
                    <th class="sorting tc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">First Name</th>
                    <th class="sorting tc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Last Name</th>
                    <th class="sorting tc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Browser: activate to sort column ascending">Performed</th>
                    <th class="sorting tc" tabindex="0" aria-controls="example1" rowspan="1" colspan="1" aria-label="Platform(s): activate to sort column ascending">in USD</th>
                  </tr>
                </thead>
                <tbody>
                  <tr role="row" class="odd tc" v-for="(x, index) in userslist" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{x.panelmember_first_name}}</td>
                    <td>{{x.panelmember_last_name}}</td>
                    <td>{{x.total_interview_count}}</td>
                    <td>${{x.amount_due}}</td>
                  </tr>
                  <tr role="row" class="odd tc" v-if="grandTotal.length > 0" style="background-color: #1d1c1c;color: white;">
                    <td>#</td>
                    <td>Grand Total</td>
                    <td></td>
                    <td>${{sum_total_interview_count}}</td>
                    <td>${{sum}}</td>
                  </tr>
                </tbody>
              </table></div></div></div>
              <!-- <div class="row" v-if="totalPages > 9">
                <div class="col-sm-3">
                  <div class="dataTables_info" id="example1_info" role="status" aria-live="polite"></div>
                </div>
                <div class="col-sm-7">
                  <jw-pagination :items="pages" @changePage="onChangePage"></jw-pagination>
                </div>
                </div> -->
              </div>
            </div>
            <!-- /.box-body -->
            <div class="modal overlay fade in" id="myModal1">
              <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
                <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
                  <div class="modal-body" style="padding:0px">
                    <div class="row" >
                      <div class="col-md-12 " style="padding:17px">
                        <div class="col-md-12" style="text-align: center;">
                          <p style="font-size: 20px;font-weight: 600;">Candidate No Show</p><br>
                          <button class="btn btn-success" @click="closeViolated()">Ok</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.modal-content -->
              </div>
            </div>
          </div>
  </section>
</template>

<script>

import axios from 'axios'
import { BaseURL } from '../../shared/classes'
import excel from 'vue-excel-export'
import router from '../../router/index'
import Vue from 'vue'
import JwPagination from 'jw-vue-pagination'
import $ from 'jquery'
// import VueDatepickerUi from 'vue-datepicker-ui'
// import 'vue-datepicker-ui/lib/vuedatepickerui.css'
import moment from 'moment'
// Register
// Vue.component('Datepicker', VueDatepickerUi)
Vue.component('jw-pagination', JwPagination)
Vue.use(excel)
export default {
  name: 'tabs-card',
  data () {
    return {
      title: '',
      pageOfItems: [],
      totalPages: 0,
      pages: [],
      showlist: false,
      config: {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      },
      viewdetails: false,
      showRole: false,
      adduser: true,
      userslistlength: '',
      userslist: [],
      sum: 0,
      sum_total_interview_count: 0,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      json_data: [],
      postdetails: [],
      grandTotal: [],
      email: '',
      base_urls: BaseURL,
      selectedDate: [],
      disabledEndDate: {
        to: new Date('01.02.2221'),
        from: new Date(new Date().getDate() + 1)
      },
      startDate: '',
      endDate: ''
    }
  },
  components: {
    // Datepicker: VueDatepickerUi
  },
  created () {
    this.getPostdata()
    this.email = this.userInfo.user_email
    this.$root.$emit('navigate', 'Report')
    var email = this.userInfo.user_email
    var sp = email.split('@')
    if (sp[1] === 'acsicorp.com') {
      this.showRole = true
    }
  },
  methods: {
    getDate (e) {
      this.startDate = moment(this.selectedDate[0]).format('YYYY-MM-DD')
      this.endDate = moment(this.selectedDate[1]).format('YYYY-MM-DD')
      this.getPostdata()
    },
    clearData () {
      this.selectedDate = []
      this.startDate = ''
      this.endDate = ''
      this.getPostdata()
    },
    closeViolated () {
      $('#myModal1').modal('hide')
    },
    openViolated () {
      $('#myModal1').modal('show')
    },
    getPostdata () {
      const mainurl = '/dashboard/get_acs_interviewer_payment_summary_report_all'
      axios.get(`${BaseURL}${mainurl}`, this.config).then(response => {
        this.userslist = response.data.interviewer_payment_summary_report_list
        this.grandTotal = response.data.interviewer_payment_summary_grandtotal
        this.sum = this.grandTotal[0].sum_amount_due
        this.sum_total_interview_count = this.grandTotal[0].sum_total_interview_count
        this.userslistlength = response.data.interviewer_payment_summary_report_list.length
      }).catch(e => {
        console.log(e)
      })
    },
    navigation (tabs) {
      router.push({ name: tabs })
    },
    viewFeedback (id) {
      const route = router.resolve({ name: 'Viewfeedback', params: { id: id } })
      window.open(route.href, '_blank')
    }
  }

}
</script>

<style scoped>
.products-list .item:hover {
  border-left: 3px solid #ffffff;
  background-color: #ffffff;
  cursor: pointer;
}
a:hover, a:active, a:focus {
  outline: none;
  text-decoration: none;
  color: #5bad2b;
}
.errorshow {
  background-color: #ff000047;
  padding: 5px;
  color: #dd4b39 !important;
}
.post li.active {
  background-color: #5bad2b !important;
  color: white;
  border: 0px !important;
}
.sideborder {
  border-right: 1px solid #cccccc52;
  min-height: 700px;
  height: 100%;
}
span.field-icon {
  position: absolute;
  display: inline-block;
  cursor: pointer;
  right: 2.5rem;
  top: 0.7rem;
  z-index: 2;
  margin-top: 4px;
}
hr {
  margin-top: 9px;
  margin-bottom: 9px;
}
.tc {
  text-align: center;
}
.table>thead>tr>th {
    border: 2px solid #f4f4f4;
    text-align: center;
}
.table>tbody>tr>td {
    border: 2px solid #f4f4f4;
    text-align: center;
}
</style>
